import { faEye, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import ShowProductModal from './ShowProductModal';
import Loader from 'Common/Loader';
import { HttpStatus } from 'modules/core';
import { GenerateReturnSaleInvoice, getReturnSalesOrderDeliveryChalan } from '../services/return-sales-service';
import notistack from 'modules/core/notistack';

interface ActionButtonsProp {
    selectedId: string;
}

const ActionButtons: React.FC<ActionButtonsProp> = ({ selectedId }) => {
    const [showViewModal, setShowViewModal] = useState(false)
    const [loading, setLoading] = useState(false)
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [showVoucherModal, setShowVoucherModal] = useState(false);


    const handleClose = () => {
        setShowViewModal(false)
    }

    const [title, setTitle] = useState("")
    const handleVoucherData = async () => {
        setLoading(true);
        try {
            const response = await GenerateReturnSaleInvoice(selectedId);
            if (response.status === HttpStatus.Success) {
                setTitle("Return Invoice");
                setPdfData(response.data);
                setShowVoucherModal(true);
            }
            else {
                notistack.notifyFromApi(response);
            }
        } catch (error) {
            notistack.error("Failed to load PDF");
            console.error("Failed to load PDF", error);
        } finally {
            setLoading(false);
        }
    };


    const handleDeliveryChalanData = async () => {
        setLoading(true);
        try {
            const response = await getReturnSalesOrderDeliveryChalan(selectedId);
            if (response.status === HttpStatus.Success) {
                setTitle("Delivery Challan");
                setPdfData(response.data.data);
                setShowVoucherModal(true);
            } else {
                notistack.notifyFromApi(response);
            }
        } catch (error) {
            notistack.error("Failed to load PDF");
            console.error("Failed to load PDF", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loading && <Loader />}
            <button className='btn btn-sm action-btn'
                onClick={() => setShowViewModal(true)}
            >
                <FontAwesomeIcon icon={faEye} className="ml-2" />
            </button>

            <button className='btn btn-sm action-btn'
                onClick={handleVoucherData}
            >
                <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-danger" title='View Return Invoice' />
            </button>

            <button className='btn btn-sm action-btn'
                onClick={handleDeliveryChalanData}
            >
                <FontAwesomeIcon icon={faFilePdf} className="ml-2 text-black" title='View Delivery Challan' />
            </button>


            <Modal size='xl' show={showViewModal} onHide={() => setShowViewModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Product</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ShowProductModal selectedId={selectedId} />
                </Modal.Body>
            </Modal>



            <Modal size='lg' show={showVoucherModal} onHide={() => setShowVoucherModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {pdfData ? (
                        <iframe
                            src={`data:application/pdf;base64,${pdfData}`}
                            title="Voucher PDF"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                        />
                    ) : (
                        <p>No PDF available.</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ActionButtons
